import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/auth/password-resets/verify/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const verify = {
  post: apiPathFunc(pathBase),
};
